import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { getLastResults, getDetailResults } from "../../../../apiservices/CasionApi";
import RefResultModal from "../../../casinoComponents/refResultModal";
import Teen6ResultBody from "../../../casinoComponents/refResultModal/Teen6ResultBody";
import { formatRefMatchTime } from "../../../../utils/refMatchTime";

/**
 * Teenpatti - 2.0 (teen6) Last Result items — reference markup inside .casino-video-last-results:
 *   <span class="resulta">A </span> / <span class="resultb"> B </span>
 * Click → .loader-overlay (in .page-content) while the round detail loads, then the reference result
 * modal ("<ename> Result", cards A=[0,2,4] / B=[1,3,5], Winner / Suit / Odd/Even / Cards / Under/Over).
 */
export default function ResultTeen6({ gameType = "teen6", fallbackTitle = "Teenpatti - 2.0" }) {
  const apiType = (gameType || "teen6").toLowerCase().trim();
  const [lastResults, setLastResults] = useState([]);
  const [detailResult, setDetailResult] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchLastResults = async () => {
      try {
        const response = await getLastResults(apiType);
        const res = response?.data?.data?.res;
        if (Array.isArray(res)) setLastResults(res);
      } catch (error) {
        console.error("Error fetching last results:", error);
      }
    };
    fetchLastResults();
    const interval = setInterval(fetchLastResults, 5000);
    return () => clearInterval(interval);
  }, [apiType]);

  const handleResultClick = async (item) => {
    if (!item?.mid) return;
    setLoading(true);
    try {
      const response = await getDetailResults(apiType, item.mid.toString());
      const t1 = response?.data?.data?.t1 ?? response?.data?.t1;
      if (t1) {
        setDetailResult(t1);
        setShowModal(true);
      }
    } catch (error) {
      console.error("Error fetching detail results:", error);
    }
    setLoading(false);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setDetailResult(null);
  };

  return (
    <>
      {lastResults.map((item, index) =>
        String(item.win) === "1" ? (
          <span key={`${item.mid}-${index}`} className="resulta" onClick={() => handleResultClick(item)}>
            A{" "}
          </span>
        ) : (
          <span key={`${item.mid}-${index}`} className="resultb" onClick={() => handleResultClick(item)}>
            {" "}B{" "}
          </span>
        )
      )}
      {loading && createPortal(<div className="loader-overlay" />, document.querySelector(".page-content") || document.body)}
      <RefResultModal
        show={showModal && !loading && !!detailResult}
        onHide={handleCloseModal}
        title={`${detailResult?.ename || fallbackTitle} Result`}
        roundId={detailResult?.rid}
        matchTime={formatRefMatchTime(detailResult?.mtime)}
      >
        <Teen6ResultBody t1={detailResult} />
      </RefResultModal>
    </>
  );
}
